import './HiveOverlay.css';
export var overlay = '_lmrhfg0-3-12-1';